/** React Query key prefix of every advisor-side quoter query (invalidated together after a write). */
export const QUOTER_QUERY_KEY = "quoter";
